import React from "react";

const BillingSignUp = () => {
  return <div>BillingSignUp</div>;
};

export default BillingSignUp;
